export const EDUCATION_LEVEL = [
  'MAPPING.EDUCATION.NONE',
  'MAPPING.EDUCATION.MS',
  'MAPPING.EDUCATION.Q_MS',
  'MAPPING.EDUCATION.MR',
  'MAPPING.EDUCATION.FA',
  'MAPPING.EDUCATION.A',
  'MAPPING.EDUCATION.OTHER',
];
